import React, { useEffect, useRef, useState } from "react";
import { parseSavedUser, buildRedirectUrl } from "./movedOverlay.utils";

const NEW_SITE_URL = process.env.REACT_APP_NEW_SITE_URL || "https://partners.strongesim.com";
const COUNTDOWN_SECONDS = 30;
const SUPPORT_WHATSAPP = "14382556657"; // digits only -> https://wa.me/<digits>

export default function MovedOverlay() {
  const [seconds, setSeconds] = useState(COUNTDOWN_SECONDS);
  const redirectedRef = useRef(false);

  const user = parseSavedUser(
    typeof window !== "undefined" ? window.localStorage.getItem("user") : null
  );
  const redirectUrl = buildRedirectUrl(user, NEW_SITE_URL);

  const goNow = () => {
    if (redirectedRef.current) return;
    redirectedRef.current = true;
    window.location.href = redirectUrl;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((s) => {
        if (s <= 1) {
          clearInterval(interval);
          goNow();
          return 0;
        }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={overlayStyle} role="dialog" aria-modal="true">
      <div style={cardStyle}>
        <div style={{ fontSize: 48, marginBottom: 8 }}>👋</div>
        <h1 style={{ margin: "0 0 8px" }}>
          {user ? `Welcome back, ${user.email}` : "Welcome"}
        </h1>
        {user && user.username ? (
          <p style={{ margin: "0 0 16px", opacity: 0.8 }}>({user.username})</p>
        ) : null}
        <p style={{ fontSize: 18, lineHeight: 1.5 }}>
          We&apos;ve moved to a new website. You&apos;ll be redirected to{" "}
          <strong>partners.strongesim.com</strong> in <strong>{seconds}</strong>{" "}
          second{seconds === 1 ? "" : "s"}.
        </p>
        <button onClick={goNow} style={buttonStyle}>
          Go to the new site now
        </button>
        <p style={{ marginTop: 24, marginBottom: 10, fontSize: 14, opacity: 0.85 }}>
          Can&apos;t log in on the new site? Contact us before you continue:
        </p>
        <a
          href={`https://wa.me/${SUPPORT_WHATSAPP}`}
          target="_blank"
          rel="noopener noreferrer"
          style={whatsappButtonStyle}
        >
          <span aria-hidden="true">💬</span> Chat with us on WhatsApp
        </a>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed", inset: 0, zIndex: 2147483647,
  background: "rgba(0,0,0,0.92)", color: "#fff",
  display: "flex", alignItems: "center", justifyContent: "center", padding: 24,
};
const cardStyle = {
  maxWidth: 480, textAlign: "center", background: "#111827",
  border: "1px solid #1f2937", borderRadius: 12, padding: 32,
};
const buttonStyle = {
  marginTop: 20, padding: "12px 24px", fontSize: 16, fontWeight: 600,
  color: "#fff", background: "#2563eb", border: "none", borderRadius: 8, cursor: "pointer",
};
const whatsappButtonStyle = {
  display: "inline-block", padding: "12px 24px", fontSize: 16, fontWeight: 600,
  color: "#fff", background: "#25D366", borderRadius: 8, textDecoration: "none",
};
